import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import { FormattedMessage } from 'react-intl'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import AccommodationRoomDetailsList from 'components/AccommodationKit/AccommodationRoomDetailsList'
import AccommodationAmenitiesList, { extractBedbankRoomPackageAmenityGroups } from 'components/AccommodationKit/AccommodationAmenitiesList'

const AboutRoomContainer = styled(Group)`
  padding: ${rem(20)};
`

interface Props {
  roomPackage: App.BedbankPackage
}

function BedbankAboutRoomModalTab(props: Props) {
  const { roomPackage } = props

  const amenityGroups = useMemo(() => extractBedbankRoomPackageAmenityGroups(roomPackage), [roomPackage])

  return (
    <AboutRoomContainer direction="vertical" gap={32}>
      <Group direction="vertical" gap={20}>
        <AccommodationRoomDetailsList roomPackage={roomPackage} />
        {!!amenityGroups.length && <Group direction="vertical" gap={12}>
          <Heading variant="heading4">
            <FormattedMessage
              id="lrc5qXMyo9n5qnavsyCM"
              defaultMessage="Room Amenities"
              description="Section heading for room amenities in bedbank about room modal"
            />
          </Heading>
          <AccommodationAmenitiesList amenities={amenityGroups} />
        </Group>}
      </Group>
    </AboutRoomContainer>
  )
}

export default BedbankAboutRoomModalTab
